import { useState } from "react";
import AbzarhaVaTajhizatSingle from "./AbzarhaVaTajhizatSingle";

export default function AbzarhaVaTajhizat({ options, setOptions, hasTitle = true, type }) {


    const handleOptions = (key) => {
        setOptions({
            ...options,
            [key]: !options[key],
        })
    }
    let optionsJSX;
    if (options) {
        optionsJSX = Object.keys(options).map((key, index) => (<AbzarhaVaTajhizatSingle label={key} key={index} data={options} handleCheck={() => handleOptions(key)} type={type} />));
    }

    return (
        <div className="flex flex-col justify-center border border-solid border-gray-200">
            {hasTitle
                ?
                <>
                    <div className="flex gap-1 justify-center items-center p-4">
                        <span>
                            ابزارها و تجهیزات مورد نیاز:
                        </span>
                        <span className="flex justify-center my-3 text-sm font-light">
                            (لطفا روی موارد موردنیاز کلیک کنید)
                        </span>
                    </div>
                </>
                :
                null}
            <div className="grid grid-cols-4">
                {optionsJSX}
            </div>
        </div>
    )
}